import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("ErrorBoundary:", error);
    const msg = String(error?.message || error?.name || "");
    if (/loading chunk|chunkloaderror|failed to fetch dynamically imported/i.test(msg)
        && !sessionStorage.getItem("fluxocrm_chunk_reload")) {
      sessionStorage.setItem("fluxocrm_chunk_reload", "1");
      window.location.reload();
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div data-testid="app-error-fallback"
        className="min-h-screen bg-zinc-950 text-zinc-100 flex flex-col items-center justify-center gap-4 px-6 text-center">
        <p className="font-semibold text-lg">Não foi possível carregar o aplicativo</p>
        <p className="text-sm text-zinc-400 max-w-sm">
          Isso pode acontecer quando o aparelho libera a memória do app em segundo plano. Toque em recarregar para voltar ao normal.
        </p>
        <button data-testid="app-error-reload-button"
          onClick={() => { sessionStorage.removeItem("fluxocrm_chunk_reload"); window.location.reload(); }}
          className="bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-semibold px-6 py-3 rounded-lg min-h-[48px]">
          Recarregar
        </button>
      </div>
    );
  }
}
